export const API_URL = process.env.REACT_APP_API_URL;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const ZOOM_URL = process.env.REACT_APP_ZOOM_URL;
export const ZOOM_GENERATE_TOKEN_URL = process.env.REACT_APP_ZOOM_GENERATE_TOKEN_URL;
export const KEYCLOAK_AUTH_URI = process.env.REACT_APP_KEYCLOAK_AUTH_URI;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
export const KEYCLOAK_SCOPE = process.env.REACT_APP_KEYCLOAK_SCOPE;
export const KEYCLOAK_REDIRECT_URI=process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;
export const KEYCLOAK_TOKEN_URL=process.env.REACT_APP_KEYCLOAK_TOKEN_URL;
export const KEYCLOAK_LOGOUT_URL=process.env.REACT_APP_KEYCLOAK_LOGOUT_URL;
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const RECAPTCHA_SITE_KEY = "6LeDr6UZAAAAALfanqCdYxmpLGTDxxl5gQ8KLZG2";
export const RECAPTCHA_SECRET_KEY = "6LeDr6UZAAAAAIUO9o68JazLENnUyQoMTGTNwilZ";